"use strict";

exports.__esModule = true;
exports.default = exports.CountdownTypes = void 0;
var CountdownTypes = {
  fixed: 'fixed',
  regular: 'regular',
  light: 'light'
};
exports.CountdownTypes = CountdownTypes;
var _default = CountdownTypes;
exports.default = _default;